import { Directive, ElementRef, HostListener, Input, NgModule, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TextMaskConfig {
  mask: Array<string | RegExp>;
  guide?: boolean;
}

@Directive({
  selector: '[textMask]'
})
export class TextMaskDirective implements OnChanges {
  @Input() textMask: TextMaskConfig;

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['textMask']) {
      this.applyMask();
    }
  }

  @HostListener('input')
  onInput(): void {
    this.applyMask();
  }

  private applyMask(): void {
    const input = this.elementRef.nativeElement;
    const mask = this.textMask && this.textMask.mask;

    if (!mask || !Array.isArray(mask) || mask.length === 0) {
      return;
    }

    const currentValue = input.value || '';
    const rawValue = this.removeMaskLiterals(currentValue, mask);
    const formattedValue = this.buildMaskedValue(rawValue, mask);

    if (formattedValue !== currentValue) {
      input.value = formattedValue;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  private removeMaskLiterals(value: string, mask: Array<string | RegExp>): string {
    const literals = new Set<string>();

    for (const token of mask) {
      if (typeof token === 'string') {
        literals.add(token);
      }
    }

    return Array.from(value)
      .filter(char => !literals.has(char))
      .join('');
  }

  private buildMaskedValue(rawValue: string, mask: Array<string | RegExp>): string {
    const source = Array.from(rawValue);
    let sourceIndex = 0;
    let result = '';

    for (const token of mask) {
      if (typeof token === 'string') {
        result += token;
        continue;
      }

      let matchedChar: string = null;
      while (sourceIndex < source.length) {
        const candidate = source[sourceIndex];
        sourceIndex += 1;

        if (token.test(candidate)) {
          matchedChar = candidate;
          break;
        }
      }

      if (matchedChar == null) {
        break;
      }

      result += matchedChar;
    }

    return result;
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [TextMaskDirective],
  exports: [TextMaskDirective]
})
export class TextMaskModule {}
